function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTxSnowFuture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.14 104.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.94,30.62a3,3,0,0,0-4.2.6l-5.31,7-3.16.36-6.88-5.2a3,3,0,0,0-4,4.44,3.33,3.33,0,0,0,.39.35l10.86,8.16a3.06,3.06,0,0,0,1.37.74h0a3.4,3.4,0,0,0,.46.06h.39l.12,0a2.93,2.93,0,0,0,.41-.07l.11,0A3,3,0,0,0,93.15,46l8.39-11.16A3,3,0,0,0,100.94,30.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.67,8.46a3,3,0,0,1-2.1-5.62c1-.37,2-.71,3-1h0c1.27-.37,2.58-.7,3.88-1a3,3,0,1,1,1.2,5.88c-1.13.23-2.27.52-3.38.85C34.43,7.84,33.54,8.14,32.67,8.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,14a42.71,42.71,0,0,0-4.4,3.79,3,3,0,0,1-4.22-4.26,47.26,47.26,0,0,1,5-4.34A3,3,0,1,1,22.5,14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87,34.21A2.86,2.86,0,0,1,4.8,34a3,3,0,0,1-1.74-3.87,47.11,47.11,0,0,1,2.81-6A3,3,0,0,1,11.12,27a41.15,41.15,0,0,0-2.45,5.26A3,3,0,0,1,5.87,34.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.13,43.41a3,3,0,1,1,6,.44C6,44.93,6,46,6,47.14c0,.83,0,1.68.09,2.51a3,3,0,0,1-2.79,3.2H3.12a3,3,0,0,1-3-2.8C0,49.1,0,48.13,0,47.18,0,45.92,0,44.65.13,43.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73,59.48A3,3,0,0,1,8.6,61.24,40.31,40.31,0,0,0,11,66.51a3,3,0,0,1-1.19,4.07A2.81,2.81,0,0,1,8.43,71a3,3,0,0,1-2.68-1.56,46.5,46.5,0,0,1-2.77-6A3,3,0,0,1,4.73,59.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.84,75.68c.65.66,1.34,1.31,2,1.92a3,3,0,0,1-3.19,5,3.08,3.08,0,0,1-.77-.5c-.8-.7-1.59-1.44-2.33-2.2a3,3,0,1,1,4.26-4.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.62,44.7l.35,0a3,3,0,0,0,2.63-3.33A46.92,46.92,0,0,0,50.19,0a3,3,0,1,0-.41,6A40.92,40.92,0,0,1,87.64,42.05,3,3,0,0,0,90.62,44.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.69,45.77l2.55-22.58a1.49,1.49,0,0,1,2.94,0L51,45.71A4.27,4.27,0,0,1,46.87,51h0A4.27,4.27,0,0,1,42.69,45.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.29,50.3,26.36,73.59a1.57,1.57,0,0,1-2.34-2L43,44.89a4.26,4.26,0,0,1,6.59-1.3h0A4.27,4.27,0,0,1,49.29,50.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,88.27l-5.29-3.06,3.17-1.37a2.19,2.19,0,1,0-1.75-4l-6.15,2.65-8.19-4.72L80.68,73l6.15,2.66a2.19,2.19,0,1,0,1.75-4L85.41,70.3l5.29-3.06a2.19,2.19,0,1,0-2.19-3.79l-5.29,3,.4-3.43a2.19,2.19,0,0,0-4.36-.49l-.77,6.65L70.3,74V64.51l5.38-4A2.19,2.19,0,1,0,73.07,57L70.3,59.05V52.93a2.19,2.19,0,1,0-4.38,0v6.12L63.15,57a2.19,2.19,0,0,0-2.61,3.52l5.38,4V74l-8.19-4.73L57,62.58a2.19,2.19,0,0,0-4.36.49L53,66.5l-5.29-3a2.19,2.19,0,1,0-2.19,3.79l5.29,3.06-3.17,1.37a2.19,2.19,0,0,0,1.75,4L55.54,73l8.19,4.73-8.19,4.72-6.15-2.65a2.19,2.19,0,1,0-1.75,4l3.17,1.37-5.29,3.06a2.19,2.19,0,1,0,2.19,3.79L53,89l-.4,3.43a2.19,2.19,0,0,0,4.36.49l.77-6.65,8.19-4.73V91l-5.38,4a2.2,2.2,0,0,0,2.61,3.53l2.77-2.06v6.11a2.19,2.19,0,0,0,4.38,0V96.47l2.77,2.06A2.2,2.2,0,0,0,75.68,95L70.3,91V81.55l8.19,4.73.77,6.65a2.19,2.19,0,0,0,4.36-.49L83.22,89l5.29,3a2.19,2.19,0,1,0,2.19-3.79Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxSnowFuture);
export default __webpack_public_path__ + "static/media/tx_SnowFuture.ef14b57e66b177a180d303452fc3c24d.svg";
export { ForwardRef as ReactComponent };